import React from 'react';
import { useSelector } from 'react-redux';

import { getViewForChart, getVisibleEntriesForView } from '../../redux/sonar/sonarSelectors';
import { SONAR_DATA_KEYS } from '../../utils/chart';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ViewRadioGroup from '../view-radio-group/ViewRadioGroup';
import { SONAR_SECTIONS } from '../../constants';
import VerticalBars from '../../components/charts/chartjs/sonar-vertical-bars/SonarVerticalBars';

const CHART_INDEX = 0;

function Rivalry() {
  const view = useSelector(getViewForChart(SONAR_SECTIONS.FRICTION, CHART_INDEX));

  //! TEMPORARY SOLUTION
  let domainEntries = useSelector(getVisibleEntriesForView(view));

  if (domainEntries.length && !domainEntries[0][SONAR_DATA_KEYS.FRICTION]) {
    domainEntries = [];
  }

  return (
    <Panel>
      <WithToolbarWrapper>
        <ViewRadioGroup chartIndex={CHART_INDEX} section={SONAR_SECTIONS.FRICTION} />

        <VerticalBars
          data={domainEntries}
          dataKey={SONAR_DATA_KEYS.FRICTION}
          height='350px'
          customTooltip
          reverseTrendGroup
          showScore
          showTrend
        />
      </WithToolbarWrapper>
    </Panel>
  );
}

export default Rivalry;
